import React from 'react';

const PartnerProsperity = React.memo(({ color, ...props }) => {

    const oyoStyle = { fill: 'var(--theme-color)' };
    const st4 = { fill: '#E53534' };

    return <svg x='8px' y='8px' viewBox='8 8 282.6 70.4' xmlSpace='preserve' {...props}>
        <g>
            <g>
                <g>
                    <text transform="matrix(1 0 0 1 137.9033 54.5576)"><tspan x="0" y="0" style={{ fill: '#020203', fontSize: 28 }}>PARTNER</tspan><tspan x="0" y="23" style={{ fill: '#020203', fontSize: 26 }}>PROSPERITY</tspan></text>
                </g>
                <g>
                    <polygon style={oyoStyle} points="181.1,8.7 173.2,8.7 169.8,15.4 166.4,8.7 158.5,8.7 165.9,23.4 165.9,30.3 173.7,30.3 173.7,23.4" />
                    <path style={oyoStyle} d="M190.7,8.5c-6.1,0-11,4.9-11,11c0,6.1,5,11,11,11c6.1,0,11-5,11-11C201.7,13.4,196.7,8.5,190.7,8.5 M190.7,23.4c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9C194.6,21.7,192.8,23.4,190.7,23.4" />
                    <path style={oyoStyle} d="M148.9,8.5c-6.1,0-11,4.9-11,11c0,6.1,5,11,11,11c6.1,0,11-5,11-11C160,13.4,155,8.5,148.9,8.5 M148.9,23.4 c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9C152.9,21.7,151.1,23.4,148.9,23.4" />
                </g>
                <g>
                    <path style={{ fill: '#020203' }} d="M84.3,31c0,0-26.8,27-28.1,27.9c-3.4,2.6-7.6,4.2-12.2,4.2c-10.9,0-19.9-8.9-19.9-19.7S33,23.6,44,23.6 c4.4,0,8.4,1.4,11.7,3.8l10.9-10.8c-6.1-5.1-14-8.2-22.6-8.2C24.6,8.5,8.8,24.1,8.8,43.4c0,19.3,15.8,34.9,35.1,34.9 c8.4,0,16.1-2.9,22.2-7.9c0.1-0.1,0.2-0.2,0.4-0.3l4.4-4.4l1-1l10.9-10.9l12.3-12.2L84.3,31z" />
                    <path style={st4} d="M54.2,55.8c0,0,26.8-27,28.1-27.9c3.4-2.6,7.6-4.2,12.2-4.2c10.9,0,19.9,8.9,19.9,19.7s-8.9,19.7-19.9,19.7 c-4.4,0-8.4-1.4-11.7-3.8L72,70.1c6.1,5.1,14,8.2,22.6,8.2c19.4,0,35.1-15.7,35.1-34.9S113.9,8.5,94.6,8.5 c-8.4,0-16.1,2.9-22.2,7.9c-0.1,0.1-0.2,0.2-0.4,0.3L67.6,21l-1,1L55.7,32.8L43.4,45L54.2,55.8z" />
                </g>
            </g>
        </g>
    </svg>
});

export default PartnerProsperity;

PartnerProsperity.defaultProps = {
    width: 141.3,
    height: 35.2,
};